import { useState, useEffect } from "react";
import * as colors from "../utils/colorsTheme";

function useColorTheme(colorTheme) {
  const [color, setColor] = useState(colors.PRIMARY);
  const [colorRGB, setColorRGB] = useState(colors.PURPLE_RGB);

  useEffect(() => {
    switch (colorTheme) {
      case colors.PURPLE:
        setColor(colors.PRIMARY);
        setColorRGB(colors.PURPLE_RGB);
        break;
      case colors.BLUE:
        setColor(colors.INFO);
        setColorRGB(colors.BLUE_RGB);
        break;
      case colors.GREEN:
        setColor(colors.SUCCESS);
        setColorRGB(colors.GREEN_RGB);
        break;
      case colors.RED:
        setColor(colors.DANGER);
        setColorRGB(colors.RED_RGB);
        break;
      case colors.ORANGE:
        setColor(colors.WARNING);
        setColorRGB(colors.ORANGE_RGB);
        break;
      case colors.ROSE:
        setColor(colors.ROSE);
        setColorRGB(colors.ROSE_RGB);
        break;

      default:
        setColor(colors.PRIMARY);
        setColorRGB(colors.PURPLE_RGB);
        break;
    }
  }, [colorTheme]);

  return { color, colorRGB };
}

export { useColorTheme };
